import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
    catalog: {},
    catalogName: "",        // 标题名
    defaultCatalogId: "",   // 默认ID
}

const mutations = {
    setCatalog(state, val) {
        state.catalog = val
    },
    setCatalogName(state, val) {
        state.catalogName = val
    },
    setDefaultCatalogId(state, val) {
        state.defaultCatalogId = val
    }
}

const actions = { }

export default new Vuex.Store({
  state,
  mutations,
  actions
})